import React from 'react';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';

//Others
import { withStyles } from '@material-ui/core/styles';
import { Component } from 'react';
import { compose } from 'recompose';
import MaterialTable from 'material-table'

//Icons
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//Others
const axios = require('axios').default;
const FormData = require('form-data');
const api_base_url = "https://e-learning-be-ybcs6wa7da-as.a.run.app";

const useStyles = theme => ({
    root: {
        margin: 15,
        marginTop: 50
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class AllTests extends Component {
    constructor() {
        super()
        this.state = {
            selectedTestType: 'IELTS',
            testsToShow: [],
            isLoadingTests: false
        };
    }

    componentDidMount = () => {
        this.handleGetAllSubmittedTests();
        document.querySelector("body").scrollTo(0, 0);
    }

    handleGetAllSubmittedTests = async () => {
        try {
            const testsToShow = [];
            const ieltsToshow = [];
            const bmatToshow = [];

            this.setState({
                isLoadingTests: true
            });

            const res = await axios({
                method: 'get',
                url: api_base_url + '/api/test/all',
                headers: {
                    "Authorization": "Bearer " + JSON.parse(localStorage.getItem('user')).token
                }
            });

            const resData = res.data;
            const ieltsArr = await resData.data.filter((test) => test.type === "IELTS");
            const bmatArr = await resData.data.filter((test) => test.type === "BMAT");

            await ieltsArr.map((test) => {
                ieltsToshow.push({
                    title: test.title,
                    description: test.description,
                    test_id: test.test_id,
                    type: test.type
                });
            })

            await bmatArr.map((test) => {
                bmatToshow.push({
                    title: test.title,
                    description: test.description,
                    test_id: test.test_id,
                    type: test.type
                });
            })

            this.setState({
                ieltsToshow: ieltsToshow,
                bmatToshow: bmatToshow,
                testInfo: resData,
                isLoadingTests: false
            });

        } catch (err) {
            console.log(err);
            this.setState({
                isLoadingTests: false
            });
        }
    }

    handleSeperateParts = () => {

    }

    handleSelectTestType = (type) => {
        this.setState({
            selectedTestType: type
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <Grid item xs={12} style={{ paddingLeft: '8px' }}>
                <Grid container spacing={2}>
                    <Grid item align='left'>
                        <Typography variant="h6" style={{ padding: '2px', fontWeight: 'bold', paddingLeft: '10px' }}>
                            Select Test
                        </Typography>
                    </Grid>
                    <Grid item align='left'>
                        <Divider orientation='vertical' />
                    </Grid>
                    <Grid item align='left'>
                        <Button
                            variant={this.state.selectedTestType === 'IELTS' ? "contained" : "outlined"}
                            style={{
                                borderColor: this.state.selectedTestType === 'IELTS' ? '' : '#76323F',
                                color: this.state.selectedTestType === 'IELTS' ? 'white' : '#76323F',
                                backgroundColor: this.state.selectedTestType === 'IELTS' ? '#76323F' : ''
                            }}
                            onClick={() => { this.handleSelectTestType('IELTS') }}
                        >
                            IELTS
                        </Button>
                        <Button
                            variant={this.state.selectedTestType === 'BMAT' ? "contained" : "outlined"}
                            style={{
                                marginLeft: '10px',
                                borderColor: this.state.selectedTestType === 'BMAT' ? '' : '#76323F',
                                color: this.state.selectedTestType === 'BMAT' ? 'white' : '#76323F',
                                backgroundColor: this.state.selectedTestType === 'BMAT' ? '#76323F' : ''
                            }}
                            onClick={() => { this.handleSelectTestType('BMAT') }}
                        >
                            BMAT
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider style={{ height: '2px', backgroundColor: '#76323F' }} />
                    </Grid>
                    <Grid item xs={12}>
                        <MaterialTable
                            data={this.state.selectedTestType === 'IELTS' ? this.state.ieltsToshow : this.state.bmatToshow}
                            columns={[
                                {
                                    title: 'Test id',
                                    field: 'test_id',
                                    editable: 'never'
                                },
                                {
                                    title: 'Title',
                                    field: 'title',
                                    editable: 'never'
                                },
                                {
                                    title: 'Description',
                                    field: 'description',
                                    editable: 'never'
                                },
                                {
                                    title: 'Type',
                                    field: 'type',
                                    editable: 'never',
                                    defaultSort: 'desc'
                                }
                            ]}
                            options={{
                                actionsColumnIndex: -1,
                                exportAllData: true,
                                exportButton: true,
                                grouping: true,
                                sorting: true,
                                pageSize: 10
                            }}
                            actions={this.state.selectedTestType === 'IELTS' ? [
                                {
                                    icon: 'edit',
                                    tooltip: 'Edit test',
                                    onClick: (event, rowData) => this.props.handleSelectTest(rowData.test_id)
                                }
                            ] : false}
                            isLoading={this.state.isLoadingTests}
                            title='Tests'
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default compose(
    withStyles(useStyles)
)(AllTests);